import React from 'react'
import { LaTercera, Laboratorio } from '@labcon/copesa-logos'
import Button from '@/components/Button'
import styled from 'styled-components'
import { Link } from 'gatsby'

const StyledHeader = styled.header`
  backdrop-filter: saturate(180%) blur(5px);
  background-color: rgba(255, 255, 255, 0.8);
`

const Header = () => (
  <StyledHeader className="fixed top-0 left-0 right-0 border-solid border-gray-300 z-20">
    <div className="flex items-center justify-between h-16 mx-auto container sm:px-4 px-2 xl:px-20">
      <Link to="/" title="ir al inicio">
        <LaTercera width="200" height="50" red="black" />
      </Link>
      {/* <Link to="/" title="ir al inicio">
        <Laboratorio width="200" height="50" />
      </Link> */}
    </div>
  </StyledHeader>
)

export default Header
